import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { pageRoutes } from "../routes/pageRoutes";
import { Formik } from "formik";
import { forgotPasswordSchema } from "../utils/schema";
import ErrorMessage from "../components/ErrorMessage";
import { authForgotPassword } from "../redux/action/authAction";
import Loader from "../components/other/Loader";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isToggle, isLoading } = useSelector((state) => state.authReducer);
  const initialValues = {
    email: "",
  };

  const handleForgetPassword = (values) => {
    const callback = (response) => {
      if (response.success) navigate(pageRoutes?.login);
    };
    dispatch(authForgotPassword({ payload: values, callback }));
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <section className="ct_login_bg_main">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xxl-5 col-xl-6 col-lg-6 col-md-6 ms-auto">
            {/* <div className="ct_grey_logo">
              <img src="assets/img/grey_logo.png" alt="Logo" />
            </div> */}
            <div className="ct_login_form_bg">
              <div className="ct_logo">
                <a href="#">
                  <img src="assets/img/logo.svg" alt="Logo" />
                </a>
              </div>
              <div className="ct_login_inner_bg">
                <Formik
                  initialValues={initialValues}
                  validationSchema={forgotPasswordSchema}
                  onSubmit={(values, actions) => {
                    handleForgetPassword(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <h3 className="ct_fs_26 ct_fw_700 ct_mb_32 text-center">
                        Forgot Password
                      </h3>
                      <div className="form-group mb-3">
                        <label className="mb-2 ct_fw_600">Email</label>
                        <input
                          type="email"
                          className="form-control ct_input"
                          id="email"
                          name="email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          placeholder="Enter email"
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="email"
                        />
                      </div>

                      <div className="mt-4">
                        <button type="submit" className="ct_orange_btn w-100">
                          Submit
                        </button>
                      </div>
                      <p className="ct_forgot_password_link text-center mt-3">
                        Already Know Your Password?{" "}
                        <a
                          href="javascript:void(0)"
                          onClick={() => navigate(pageRoutes.login)}
                          className="ct_fw_600"
                        >
                          Login
                        </a>
                      </p>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
